module.exports = __webpack_public_path__ + "img/info_btn.26a871b5.png";